export const INVENTORY_ITEMS = {
  NUMENS: 'numens',
  FACTION_SKIN: 'faction_skin',
  FACTION_SKIN_IMPLEMENTED: 'faction_skin_implemented',
  FACTION_UNIT_SKIN: 'faction_unit_skin',
  FACTION_UNIT_SKIN_IMPLEMENTED: 'faction_unit_skin_implemented',
  FACTION: 'faction',
  CRYSTALS: 'crystals',
  PREMIUM: 'premium',
  ALL_FACTIONS: 'all_factions',
  CHEST: 'chest',
}